const PassThroughKeyed = () => import('@/views/PassThroughKeyed.vue');

export default {
  path: '/members',
  name: 'members',
  component: PassThroughKeyed,
  children: [
    {
      name: 'members-members',
      path: 'members',
      redirect: '/v3/members/members',
      meta: {
        title: 'members',
      },
    },
    {
      name: 'member-groups',
      path: 'member-groups',
      redirect: '/v3/members/member-groups',
      meta: {
        title: 'member-groups',
      },
    },
    {
      name: 'memberships',
      path: 'memberships',
      redirect: '/v3/members/memberships',
      meta: {
        title: 'memberships',
      },
      children: [
        {
          path: 'membership',
          redirect: '/v3/members/memberships/membership',
        },
      ],
    },
  ],
};
